// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"55":"ea4e565f98062f7f10ad","924":"3346b28be9e2cae9f045","925":"3aa18f8cb1aee35464b3"}[chunkId] + ".js";
};